import {
  aSignal,
  mockSuppressedSignalQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockSuppressedSignalQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          // @ts-ignore contentTypeEnum is aliased which causes issues with typing since MSW doesn't handle this case
          signal: aSignal(),
        },
      });
    }
  ),
];
